var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconStepsPrev = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 15,
  viewBox: "0 0 20 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20,4.571,6.394,19,0,11.455l.634-.54,5.792,6.836L19.393,4Z",
  transform: "translate(0 -4)",
  fill: "#E6E6E6"
})));
export default SvgIconStepsPrev;